<div #overlay class="overlay" id="custom-overlay">
  <div class="modal-container" id="custom-overlay-container">
    <ng-template appModalContent></ng-template>
  </div>
</div>
